import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'actions';
import {showPopup} from 'helpers/modal';
import UserAgent from 'helpers/device';

class ResetSettings extends Component {
    onClick() {
        const onConfirm = function () {
            this.props.dispatch(Action.do('resetSettings'));
            this.props.dispatch(showPopup('Settings were successfully reset!'));
        }.bind(this);

        this.props.dispatch(
            showPopup('Are you sure?', {
                onConfirm,
                useCancel: true,
            }),
        );
    }

    render() {
        const buttonAttributes = {
            type: 'button',
            className: 'btn-text',
            ...(!UserAgent.isMobile() && {'data-tooltip-html': 'Reset settings'}),
        };

        return (
            <button {...buttonAttributes} onClick={this.onClick.bind(this)}>
                <i className="fa fa-times-circle"></i>
                {UserAgent.isMobile() ? 'Reset settings' : 'Reset'}
            </button>
        );
    }
}

export default connect(() => ({}))(ResetSettings);
